import { render, staticRenderFns } from "./AssociateProfForm.vue?vue&type=template&id=00d9d0e8&scoped=true"
import script from "./AssociateProfForm.vue?vue&type=script&lang=js"
export * from "./AssociateProfForm.vue?vue&type=script&lang=js"
import style0 from "./AssociateProfForm.vue?vue&type=style&index=0&id=00d9d0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d9d0e8",
  null
  
)

export default component.exports